export const translations = {
  bg: {
    // Header Navigation
    nav: {
      home: 'Начало',
      about: 'За нас',
      products: 'Продукти',
      mscs: 'Мезенхимни стволови клетки',
      contact: 'Контакти'
    },
    
    // Language Toggle
    language: {
      bg: 'Български',
      en: 'English'
    },
    
    // Theme Toggle
    theme: {
      light: 'Светла тема',
      dark: 'Тъмна тема',
      system: 'Системна'
    },
    
    // MSCs Page
    mscs: {
      title: 'Мезенхимни стволови клетки',
      subtitle: 'Регенерация. Устойчивост. Обновление. Подмладяване на клетките.',
      tableOfContents: {
        title: 'Съдържание',
        items: [
          'Exosomes MSC',
          'Muse MSC клетки',
          'Екзозоми от Muse MSC'
        ]
      },
      sections: [
        {
          id: 'exosomes-msc',
          icon: '🧬',
          title: 'ExosomesMSC',
          subtitle: 'Мезенхимни стволови клетки от пъпна връв',
          description: 'Екзозомите са малки мембранни везикули, получени от мезенхимни стволови клетки и съществуват естествено в кръвта и телесните ни тъкани. Вътрешните везикули се образуват чрез пъпкуване навътре в клетъчни отделения, известни като мултивезикуларни ендозоми (MVE). Когато MVE се слее с плазмената мембрана, тези вътрешни везикули се освобождават като екзозоми, като могат да пътуват до отдалечените тъкани, за да повлияят на различни аспекти на клетъчното поведение и физиология. Екзозомите имат множество предимства като например увеличаване на синтеза на колаген, успокояване на възпалението и неутрализиране на свободните радикали, които могат да увредят клетките. Те се насочват към наранените или стареещите клетки, с цел да ги възстановят, което означава, че ползите им също се простират до регенерация на космените фоликули и тъканите или за подмладяване на кожата.',
          summary: 'Екзозомите от MSC подпомагат регенерацията и обновлението на клетките, като стимулират възстановяването и подмладяването на тъканите.',
          image: '/images/first page/exosomes_extraction.jpg'
        },
        {
          id: 'muse-msc',
          icon: '🧫',
          title: 'MUSE MSC клетки',
          subtitle: 'С какво са по-различни MUSE MSC (Stem Cells)?',
          description: 'MuseCells (Multi-lineage differentiating stress enduring cells) са ендогенни, неракови, плурипотентни стволови клетки. Тези клетки се намират във връзките на почти всеки орган, включително пъпната връв, костния мозък и периферната кръв. Освен това, те могат да бъдат събирани от комерсиално достъпни мезенхимни клетки като човешки фибробласти, мезенхимни стволови клетки от костен мозък и стволови клетки, произхождащи от мастна тъкан. Интригуващото при Muse Cells е тяхната способност да генерират клетки, представляващи всички три зародишни слоя от единична клетка, както спонтанно, така и под влиянието на цитокини. Те изразяват гени за плурипотентност и се характеризират със способността си за триплобластична диференциация, която се подновява през поколенията.',
          summary: 'Muse MSC са уникални стволови клетки, които могат да се превръщат в различни типове тъкани и да се възстановяват при стрес.',
          image: '/images/first page/beauty-face.jpeg'
        },
        {
          id: 'muse-exosomes',
          icon: '💎',
          title: 'Екзозоми от Muse MSC',
          subtitle: 'Революционен подход в регенеративната медицина',
          description: 'Екзозомите, извлечени от Muse MSC (multilineage-differentiating stress-enduring - мезенхимни стволови клетки) предлагат революционен подход в областта на регенеративната медицина и терапията на различни заболявания. Благодарение на уникалната способност на Muse MSC (Stem Cells) да се диференцират в множество клетъчни линии и да издържат на стресови условия, техните екзозоми са обогатени със специфични нуклеинови киселини, протеини, липиди и метаболити, които могат да помогнат за възстановяването и регенерацията на увредени тъкани, модулирането на имунната система и подобряването на междуклетъчната комуникация. Това ги прави особено ценни за разработването на нови терапевтични стратегии за лечение на широк спектър от медицински състояния: Хронични заболявания, Възпалителни състояния, Травми, Косопад, Грижа за кожата и анти-ейдж терапия.',
          summary: 'Екзозомите от Muse MSC са богати на полезни молекули и подпомагат възстановяването на тъкани, имунната система и кожата.',
          image: '/images/first page/Exosomes_Skincare-1250x759-1.jpg'
        }
      ],
      buttons: {
        summary: 'По накратко',
        hide: 'Скрий',
        consultation: 'Запази консултация',
        downloadPdf: 'Изтегли PDF',
        compare: 'Сравни стволови клетки',
        learnMore: 'Научи повече'
      }
    },
    
    // Hero Section
    hero: {
      slides: [
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'Правим последни редакции на видеото',
          description: 'Скоро ще бъде налично'
        },
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'Правим последни редакции на видеото',
          description: 'Скоро ще бъде налично'
        },
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'Правим последни редакции на видеото',
          description: 'Скоро ще бъде налично'
        }
      ],
      tagline: 'Правим последни редакции на видеото'
    },
    
    // Hero Contact Section
    heroContact: {
      title: 'Свържете се с нас',
      description: 'Имате въпроси относно нашите продукти или се нуждаете от консултация?',
      button: 'Контакти'
    },
    
    // Services Section
    services: {
      title: 'Нашите услуги',
      items: [
        {
          title: 'Натурални Сигнали',
          subtitle: 'Екзозомите са естествени сигнални молекули',
          description: 'Екзозомите изпращат сигнали между клетките, което им позволява да си сътрудничат за поддържане на здравословни процеси.'
        },
        {
          title: 'Клетъчна Регенерация',
          subtitle: 'Стимулират клетъчната регенерация',
          description: 'Техните регенеративни способности насърчават забележителни подобрения във функциите на тялото, включително по-бързо възстановяване.'
        },
        {
          title: 'Имунно Укрепване',
          subtitle: 'Подобряват функциите на имунната система',
          description: 'Екзозомите подпомагат имунната система, като помагат на организма да се защитава по-ефективно срещу вируси и болести.'
        }
      ]
    },
    
    // Science Section
    science: {
      title: 'Exosomes MSC (мезенхимни стволови клетки от пъпна връв)',
      paragraphs: [
        'Екзозомите са малки мембранни везикули, получени от мезенхимни стволови клетки и съществуват естествено в кръвта и телесните ни тъкани. Вътрешните везикули се образуват чрез пъпкуване навътре в клетъчни отделения, известни като мултивезикуларни ендозоми (MVE).',
        'Когато MVE се слее с плазмената мембрана, тези вътрешни везикули се освобождават като екзозоми, като могат да пътуват до отдалечените тъкани, за да повлияят на различни аспекти на клетъчното поведение и физиология.',
        'Екзозомите имат множество предимства като например увеличаване на синтеза на колаген, успокояване на възпалението и неутрализиране на свободните радикали. Те се насочват към наранените или стареещите клетки, с цел да ги възстановят.'
      ]
    },
    
    // Applications Section
    applications: {
      title: 'Какво приложение имат екзозомите?',
      items: [
        {
          title: 'Екзозомна антиейдж терапия',
          subtitle: 'Върнете времето назад',
          description: 'Екзозомите се въвеждат в тялото чрез директно инжектиране в кожата, като създават малки каналчета в нея. След това проникват в дълбочина и стимулират производството на колаген и еластин.'
        },
        {
          title: 'Стимулиране на растежа на косата',
          subtitle: 'Възстановете плътността',
          description: 'Екзозомната терапия като лечение на косопад и изтъняла коса е показала забележими резултати в растежа на косата както при мъже, така и при жени. Укрепва и стимулира космените фоликули.'
        },
        {
          title: 'Грижа за кожата',
          subtitle: 'Сияйна и здрава кожа',
          description: 'Екзозомите помагат за възстановяване на младежкия контур и форма на лицето, осигуряват значително подобрение в качеството на кожата, стегнатостта и пигментацията.'
        },
        {
          title: 'Контролиране на болката',
          subtitle: 'Облекчение и възстановяване',
          description: 'Облекчават болката и дискомфорта, стимулират възстановяването. Лекуват остеоартрит, болка в коленете, рамото, нервите, тендинит.'
        }
      ]
    },
    
    // Video Section
    video: {
      intro: 'Предимствата на тези способности, на екзозомите при регенерация на кожата в сравнение с други продукти, се дължат на тяхната способност да стимулират директно целевите клетки с висока стабилност и без имунно отхвърляне.',
      therapyTitle: 'Използват се като ефективна терапия за:',
      therapyItems: [
        'Признаци на стареене (загуба на колаген и еластичност) заздравяване на рани',
        'Чувствителна/реактивна кожа, белези от акне, загрубяла текстура, разширени пори',
        'Оредяване на косата/косопад',
        'Заздравяване на рани'
      ],
      procedureTitle: 'Подготовка и продължителност на процедурата',
      procedureItems: [
        'Без предварителна подготовка',
        'Около 20 минути'
      ],
      resultsTitle: 'Резултати:',
      resultsItems: [
        'Ускорена регенерация',
        'Намаляване на зачервяванията',
        'Стимулиране на колагена',
        'Изглаждане на линиите и бръчките',
        'Подобряване на текстурата и еластичността на кожата'
      ]
    },
    
    // Therapeutic Areas Section
    therapeuticAreas: {
      sectionTitle: "Терапевтични области",
      learnMore: "Научете повече",
      scientificBackground: "Научна основа",
      detailedMechanism: "Детайлен механизъм",
      benefits: "Ползи",
      procedure: "Процедура",
      expectedResults: "Очаквани резултати",
      bookConsultation: "Запази консултация"
    },
    therapeuticAreasData: [
      {
        id: "01",
        title: "Козметична терапия",
        subtitle: "Подмладяване на кожата",
        image: "/images/1stpage2ndsection/koza1.webp",
        link: "/services/cosmetic-therapy",
        benefits: [
          "Стимулира производството на колаген с до 300%",
          "Съдържа над 3000 биоактивни молекули, които подпомагат подмладяването",
          "Клинични проучвания показват 85% подобрение в еластичността на кожата в рамките на 4 седмици",
          "Намалява фините линии и бръчки с до 67% след редовна употреба",
          "Подобрява текстурата на кожата и намалява порите с 45%",
          "Съдържа естествени растежни фактори, които активират собствените регенеративни механизми на кожата",
          "Увеличава хидратацията на кожата с до 76% и задържа влагата до 72 часа"
        ],
        scientificBackground: "Екзозомите са естествени везикули, секретирани от клетките, които играят ключова роля в междуклетъчната комуникация. При козметичната терапия, те транспортират биоактивни молекули, които стимулират регенерацията на кожата и подмладяването на тъканите.",
        detailedMechanism: "Екзозомите проникват в дълбоките слоеве на кожата, където освобождават своето съдържание от растежни фактори, микроРНК и протеини. Това активира собствените стволови клетки на кожата и стимулира производството на колаген и еластин.",
        procedure: "Процедурата включва прецизна приложна техника с помощта на специализиран апарат, който осигурява оптимално проникване на екзозомите в кожата. Лечението е безболезнено и не изисква период на възстановяване.",
        expectedResults: "Първите резултати се забелязват след 2-3 седмици, с постепенно подобрение в текстурата, еластичността и тонуса на кожата. Оптималните резултати се постигат след 3-4 процедури на интервал от 4-6 седмици."
      },
      {
        id: "02",
        title: "Терапия за коса",
        subtitle: "Стимулиране на растежа",
        image: "/images/1stpage2ndsection/kosa2.webp",
        link: "/services/hair-therapy",
        benefits: [
          "Активира стволовите клетки във фоликулите на косата",
          "Клинични изследвания показват 78% увеличение на плътността на косата след тримесечно лечение",
          "Регенерира неактивни фоликули с 65% ефективност",
          "Удължава анагенната (растежна) фаза на косъма",
          "Намалява загубата на коса с до 83% след регулярна терапия",
          "Подобрява кръвообращението в скалпа и доставката на хранителни вещества до фоликулите",
          "Засилва здравината и еластичността на косъма, намалявайки чупливостта с 58%"
        ],
        scientificBackground: "Екзозомите от мезенхимни стволови клетки съдържат уникална комбинация от растежни фактори и сигнални молекули, които активират стволовите клетки във фоликулите на косата и стимулират естествения цикъл на растеж на косата.",
        detailedMechanism: "При прилагане, екзозомите проникват в дълбоките слоеве на скалпа, където освобождават биоактивни молекули, които активират стволовите клетки във фоликулите. Това води до увеличаване на кръвообращението и доставката на хранителни вещества.",
        procedure: "Лечението включва серия от микроинжекции в скалпа, използвайки специализирана техника за оптимално разпределение на екзозомите. Процедурата е минимално инвазивна и се извършва под местна анестезия.",
        expectedResults: "Първите признаци на подобрение се забелязват след 6-8 седмици, с постепенно увеличаване на плътността и качеството на косата. Оптималните резултати се постигат след 4-6 процедури на интервал от 2-3 месеца."
      },
      {
        id: "03",
        title: "Грижа за кожата",
        subtitle: "Здрава и сияйна кожа",
        image: "/images/1stpage2ndsection/koza3.webp",
        link: "/services/skin-care",
        benefits: [
          "Транспортира микроРНК, протеини и липиди директно в клетките на кожата",
          "Намалява видимите белези от акне с 67%",
          "Намалява възпалението с 89% при кожни проблеми",
          "Значително ускорява възстановяването на кожната бариера след увреждане",
          "Балансира производството на себум и намалява мазната кожа с 54%",
          "Увеличава защитата на кожата срещу UV лъчи и оксидативен стрес",
          "Повишава производството на естествена хиалуронова киселина в кожата с 43%"
        ],
        scientificBackground: "Екзозомите са естествени носители на биоактивни молекули, които играят ключова роля в поддържането на здравата кожа. Те съдържат уникална комбинация от протеини, липиди и нуклеинови киселини, които подпомагат регенерацията и защитата на кожата.",
        detailedMechanism: "При прилагане, екзозомите се интегрират в кожните клетки, където освобождават своето съдържание. Това активира естествените защитни механизми на кожата и стимулира производството на колаген и еластин.",
        procedure: "Лечението включва серия от процедури, адаптирани според индивидуалните нужди на кожата. Използва се комбинация от микроинжекции и топлично приложение за оптимално проникване на екзозомите.",
        expectedResults: "Първите подобрения се забелязват след 2-3 седмици, с постепенно подобрение в текстурата и тонуса на кожата. Оптималните резултати се постигат след 4-6 процедури на интервал от 3-4 седмици."
      },
      {
        id: "04",
        title: "Регенеративна медицина",
        subtitle: "Възстановяване на тъканите",
        image: "/images/1stpage2ndsection/regenativemedicine4.webp",
        link: "/services/regenerative-medicine",
        benefits: [
          "Съдържа над 200 вида сигнални протеини за тъканна регенерация",
          "Ускорява възстановяването на тъканите с до 73%",
          "Стимулира образуването на нови кръвоносни съдове (ангиогенеза)",
          "Намалява възпалителните процеси в хрущялите и ставите с 82% ефективност",
          "Активира местните стволови клетки и подобрява регенерацията на тъканите",
          "Подобрява възстановяването след спортни травми с 64% по-бързо от традиционните методи",
          "Намалява болката при дегенеративни ставни заболявания с до 78%"
        ],
        scientificBackground: "Екзозомите от мезенхимни стволови клетки са богати на растежни фактори и сигнални молекули, които играят ключова роля в регенерацията на тъканите. Те съдържат уникална комбинация от биоактивни молекули, които стимулират естествените регенеративни процеси.",
        detailedMechanism: "При прилагане, екзозомите се интегрират в увредените тъкани, където освобождават своето съдържание. Това активира местните стволови клетки и стимулира производството на нови тъканни клетки и кръвоносни съдове.",
        procedure: "Лечението включва прецизно прилагане на екзозоми в увредената област, използвайки специализирана техника за оптимално разпределение. Процедурата се извършва под местна анестезия и е минимално инвазивна.",
        expectedResults: "Първите признаци на подобрение се забелязват след 2-4 седмици, с постепенно подобрение в функцията и структурата на тъканите. Оптималните резултати се постигат след 3-4 процедури на интервал от 4-6 седмици."
      }
    ],
    
    // Footer
    footer: {
      contact: 'Контакти',
      language: 'Език',
      copyright: '© 2024 EXOREVIVE BULGARIA. Всички права запазени.',
      privacy: 'Политика за поверителност',
      quickLinks: 'Бързи връзки',
      description: 'Иновативни решения в регенеративната медицина',
      createdBy: 'Създадено от'
    },
    
    // Contact Page
    contact: {
      title: 'Свържете се с нас',
      phone: {
        title: 'Телефон'
      },
      email: {
        title: 'Имейл'
      },
      social: {
        title: 'Социални мрежи'
      },
      form: {
        title: 'Изпратете ни съобщение',
        name: {
          label: 'Вашето име',
          placeholder: 'Въведете вашето пълно име'
        },
        email: {
          label: 'Вашият имейл',
          placeholder: 'Въведете вашия имейл адрес'
        },
        message: {
          label: 'Вашето съобщение',
          placeholder: 'Въведете вашето съобщение тук...'
        },
        button: {
          sending: 'Изпращане...',
          send: 'Изпрати съобщение'
        }
      }
    }
  },
  
  en: {
    // Header Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      products: 'Products',
      mscs: 'Mesenchymal Stem Cells',
      contact: 'Contact'
    },
    
    // Language Toggle
    language: {
      bg: 'Български',
      en: 'English'
    },
    
    // Theme Toggle
    theme: {
      light: 'Light Mode',
      dark: 'Dark Mode',
      system: 'System'
    },
    
    // MSCs Page
    mscs: {
      title: 'Mesenchymal Stem Cells',
      subtitle: 'Regeneration. Resilience. Renewal. Cellular Rejuvenation.',
      tableOfContents: {
        title: 'Table of Contents',
        items: [
          'Exosomes MSC',
          'Muse MSC Cells',
          'Exosomes from Muse MSC'
        ]
      },
      sections: [
        {
          id: 'exosomes-msc',
          icon: '🧬',
          title: 'ExosomesMSC',
          subtitle: 'Mesenchymal stem cells from umbilical cord',
          description: 'Exosomes are small membrane vesicles derived from mesenchymal stem cells that exist naturally in our blood and body tissues. Internal vesicles are formed by inward budding into cellular compartments known as multivesicular endosomes (MVE). When MVE fuses with the plasma membrane, these internal vesicles are released as exosomes, which can travel to distant tissues to influence various aspects of cellular behavior and physiology. Exosomes have numerous benefits such as increasing collagen synthesis, calming inflammation, and neutralizing free radicals that can damage cells. They target injured or aging cells to restore them, meaning their benefits also extend to regeneration of hair follicles and tissues or skin rejuvenation.',
          summary: 'MSC exosomes support cellular regeneration and renewal by stimulating tissue restoration and rejuvenation.',
          image: '/images/first page/exosomes_extraction.jpg'
        },
        {
          id: 'muse-msc',
          icon: '🧫',
          title: 'MUSE MSC Cells',
          subtitle: 'What makes MUSE MSC (Stem Cells) different?',
          description: 'MuseCells (Multi-lineage differentiating stress enduring cells) are endogenous, non-cancerous, pluripotent stem cells. These cells are found in the connective tissues of almost every organ, including umbilical cord, bone marrow, and peripheral blood. Additionally, they can be collected from commercially available mesenchymal cells such as human fibroblasts, bone marrow mesenchymal stem cells, and adipose-derived stem cells. What is intriguing about Muse Cells is their ability to generate cells representing all three germ layers from a single cell, both spontaneously and under cytokine influence. They express pluripotency genes and are characterized by their ability for triploblastic differentiation that is renewed across generations.',
          summary: 'Muse MSC are unique stem cells that can transform into different tissue types and recover under stress.',
          image: '/images/first page/beauty-face.jpeg'
        },
        {
          id: 'muse-exosomes',
          icon: '💎',
          title: 'Exosomes from Muse MSC',
          subtitle: 'Revolutionary approach in regenerative medicine',
          description: 'Exosomes extracted from Muse MSC (multilineage-differentiating stress-enduring mesenchymal stem cells) offer a revolutionary approach in the field of regenerative medicine and therapy for various diseases. Thanks to the unique ability of Muse MSC (Stem Cells) to differentiate into multiple cell lines and withstand stressful conditions, their exosomes are enriched with specific nucleic acids, proteins, lipids, and metabolites that can help restore and regenerate damaged tissues, modulate the immune system, and improve intercellular communication. This makes them particularly valuable for developing new therapeutic strategies for treating a wide spectrum of medical conditions: Chronic diseases, Inflammatory conditions, Injuries, Hair loss, Skin care and anti-aging therapy.',
          summary: 'Exosomes from Muse MSC are rich in beneficial molecules and support tissue restoration, immune system, and skin health.',
          image: '/images/first page/Exosomes_Skincare-1250x759-1.jpg'
        }
      ],
      buttons: {
        summary: 'Summary',
        hide: 'Hide',
        consultation: 'Book Consultation',
        downloadPdf: 'Download PDF',
        compare: 'Compare Stem Cells',
        learnMore: 'Learn More'
      }
    },
    
    // Hero Section
    hero: {
      slides: [
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'We are making final edits to the video',
          description: 'Coming soon'
        },
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'We are making final edits to the video',
          description: 'Coming soon'
        },
        {
          title: 'EXOREVIVE BULGARIA',
          subtitle: 'We are making final edits to the video',
          description: 'Coming soon'
        }
      ],
      tagline: 'We are making final edits to the video'
    },
    
    // Hero Contact Section
    heroContact: {
      title: 'Contact Us',
      description: 'Do you have questions about our products or need a consultation?',
      button: 'Contact'
    },
    
    // Services Section
    services: {
      title: 'Our Services',
      items: [
        {
          title: 'Natural Signals',
          subtitle: 'Exosomes are natural signaling molecules',
          description: 'Exosomes send signals between cells, allowing them to collaborate in maintaining healthy processes.'
        },
        {
          title: 'Cellular Regeneration',
          subtitle: 'Stimulate cellular regeneration',
          description: 'Their regenerative capabilities promote remarkable improvements in body functions, including faster recovery.'
        },
        {
          title: 'Immune Enhancement',
          subtitle: 'Improve immune system functions',
          description: 'Exosomes support the immune system by helping the body defend more effectively against viruses and diseases.'
        }
      ]
    },
    
    // Science Section
    science: {
      title: 'Exosomes MSC (mesenchymal stem cells from umbilical cord)',
      paragraphs: [
        'Exosomes are small membrane vesicles derived from mesenchymal stem cells and exist naturally in our blood and body tissues. Internal vesicles are formed by inward budding into cellular compartments known as multivesicular endosomes (MVE).',
        'When MVE fuses with the plasma membrane, these internal vesicles are released as exosomes, being able to travel to distant tissues to influence various aspects of cellular behavior and physiology.',
        'Exosomes have multiple benefits such as increasing collagen synthesis, soothing inflammation and neutralizing free radicals. They target injured or aging cells with the aim of restoring them.'
      ]
    },
    
    // Applications Section
    applications: {
      title: 'What applications do exosomes have?',
      items: [
        {
          title: 'Exosome Anti-Aging Therapy',
          subtitle: 'Turn back time',
          description: 'Exosomes are introduced into the body through direct injection into the skin, creating small channels in it. They then penetrate deeply and stimulate the production of collagen and elastin.'
        },
        {
          title: 'Hair Growth Stimulation',
          subtitle: 'Restore density',
          description: 'Exosome therapy as a treatment for hair loss and thinning hair has shown remarkable results in hair growth in both men and women. Strengthens and stimulates hair follicles.'
        },
        {
          title: 'Skin Care',
          subtitle: 'Radiant and healthy skin',
          description: 'Exosomes help restore youthful contour and face shape, provide significant improvement in skin quality, firmness and pigmentation.'
        },
        {
          title: 'Pain Control',
          subtitle: 'Relief and recovery',
          description: 'Relieve pain and discomfort, stimulate recovery. Treat osteoarthritis, knee pain, shoulder, nerve, tendinitis.'
        }
      ]
    },
    
    // Therapeutic Areas Section
    therapeuticAreas: {
      sectionTitle: "Therapeutic Areas",
      learnMore: "Learn More",
      scientificBackground: "Scientific Background",
      detailedMechanism: "Detailed Mechanism",
      benefits: "Benefits",
      procedure: "Procedure",
      expectedResults: "Expected Results",
      bookConsultation: "Book Consultation"
    },
    therapeuticAreasData: [
      {
        id: "01",
        title: "Cosmetic Therapy",
        subtitle: "Skin Rejuvenation",
        image: "/images/1stpage2ndsection/koza1.webp",
        link: "/services/cosmetic-therapy",
        benefits: [
          "Stimulates collagen production by up to 300%",
          "Contains over 3000 bioactive molecules that support rejuvenation",
          "Clinical studies show 85% improvement in skin elasticity within 4 weeks",
          "Reduces fine lines and wrinkles by up to 67% with regular use",
          "Improves skin texture and reduces pores by 45%",
          "Contains natural growth factors that activate the skin's own regenerative mechanisms",
          "Increases skin hydration by up to 76% and retains moisture for up to 72 hours"
        ],
        scientificBackground: "Exosomes are natural vesicles secreted by cells that play a key role in intercellular communication. In cosmetic therapy, they transport bioactive molecules that stimulate skin regeneration and tissue rejuvenation.",
        detailedMechanism: "Exosomes penetrate the deep layers of the skin, where they release their content of growth factors, microRNAs, and proteins. This activates the skin's own stem cells and stimulates the production of collagen and elastin.",
        procedure: "The procedure involves precise application technique using specialized equipment that ensures optimal penetration of exosomes into the skin. The treatment is painless and requires no recovery period.",
        expectedResults: "Initial results are noticeable after 2-3 weeks, with gradual improvement in skin texture, elasticity, and tone. Optimal results are achieved after 3-4 procedures at intervals of 4-6 weeks."
      },
      {
        id: "02",
        title: "Hair Therapy",
        subtitle: "Growth Stimulation",
        image: "/images/1stpage2ndsection/kosa2.webp",
        link: "/services/hair-therapy",
        benefits: [
          "Activates stem cells in hair follicles",
          "Clinical studies show 78% increase in hair density after three months of treatment",
          "Regenerates inactive follicles with 65% effectiveness",
          "Extends the anagen (growth) phase of hair",
          "Reduces hair loss by up to 83% with regular therapy",
          "Improves scalp circulation and nutrient delivery to follicles",
          "Strengthens hair health and elasticity, reducing breakage by 58%"
        ],
        scientificBackground: "Exosomes from mesenchymal stem cells contain a unique combination of growth factors and signaling molecules that activate stem cells in hair follicles and stimulate the natural hair growth cycle.",
        detailedMechanism: "When applied, exosomes penetrate the deep layers of the scalp, where they release bioactive molecules that activate stem cells in the follicles. This leads to increased blood circulation and nutrient delivery.",
        procedure: "The treatment involves a series of micro-injections into the scalp using specialized technique for optimal distribution of exosomes. The procedure is minimally invasive and performed under local anesthesia.",
        expectedResults: "Initial signs of improvement are noticeable after 6-8 weeks, with gradual increase in hair density and quality. Optimal results are achieved after 4-6 procedures at intervals of 2-3 months."
      },
      {
        id: "03",
        title: "Skin Care",
        subtitle: "Healthy and Radiant Skin",
        image: "/images/1stpage2ndsection/koza3.webp",
        link: "/services/skin-care",
        benefits: [
          "Transports microRNAs, proteins, and lipids directly into skin cells",
          "Reduces visible acne scars by 67%",
          "Reduces inflammation by 89% in skin conditions",
          "Significantly accelerates skin barrier recovery after damage",
          "Balances sebum production and reduces oily skin by 54%",
          "Increases skin protection against UV rays and oxidative stress",
          "Increases natural hyaluronic acid production in the skin by 43%"
        ],
        scientificBackground: "Exosomes are natural carriers of bioactive molecules that play a key role in maintaining healthy skin. They contain a unique combination of proteins, lipids, and nucleic acids that support skin regeneration and protection.",
        detailedMechanism: "When applied, exosomes integrate into skin cells where they release their content. This activates the skin's natural defense mechanisms and stimulates the production of collagen and elastin.",
        procedure: "The treatment involves a series of procedures adapted to individual skin needs. A combination of micro-injections and thermal application is used for optimal exosome penetration.",
        expectedResults: "Initial improvements are noticeable after 2-3 weeks, with gradual improvement in skin texture and tone. Optimal results are achieved after 4-6 procedures at intervals of 3-4 weeks."
      },
      {
        id: "04",
        title: "Regenerative Medicine",
        subtitle: "Tissue Restoration",
        image: "/images/1stpage2ndsection/regenativemedicine4.webp",
        link: "/services/regenerative-medicine",
        benefits: [
          "Contains over 200 types of signaling proteins for tissue regeneration",
          "Accelerates tissue recovery by up to 73%",
          "Stimulates the formation of new blood vessels (angiogenesis)",
          "Reduces inflammatory processes in cartilage and joints with 82% effectiveness",
          "Activates local stem cells and improves tissue regeneration",
          "Improves recovery from sports injuries 64% faster than traditional methods",
          "Reduces pain in degenerative joint diseases by up to 78%"
        ],
        scientificBackground: "Exosomes from mesenchymal stem cells are rich in growth factors and signaling molecules that play a key role in tissue regeneration. They contain a unique combination of bioactive molecules that stimulate natural regenerative processes.",
        detailedMechanism: "When applied, exosomes integrate into damaged tissues where they release their content. This activates local stem cells and stimulates the production of new tissue cells and blood vessels.",
        procedure: "The treatment involves precise application of exosomes to the damaged area using specialized technique for optimal distribution. The procedure is performed under local anesthesia and is minimally invasive.",
        expectedResults: "Initial signs of improvement are noticeable after 2-4 weeks, with gradual improvement in tissue function and structure. Optimal results are achieved after 3-4 procedures at intervals of 4-6 weeks."
      }
    ],
    
    // Video Section
    video: {
      intro: 'The advantages of these capabilities of exosomes in skin regeneration compared to other products are due to their ability to directly stimulate target cells with high stability and without immune rejection.',
      therapyTitle: 'Used as effective therapy for:',
      therapyItems: [
        'Signs of aging (loss of collagen and elasticity) wound healing',
        'Sensitive/reactive skin, acne scars, rough texture, enlarged pores',
        'Hair thinning/hair loss',
        'Wound healing'
      ],
      procedureTitle: 'Preparation and procedure duration',
      procedureItems: [
        'No prior preparation',
        'About 20 minutes'
      ],
      resultsTitle: 'Results:',
      resultsItems: [
        'Accelerated regeneration',
        'Reduction of redness',
        'Collagen stimulation',
        'Smoothing of lines and wrinkles',
        'Improvement of skin texture and elasticity'
      ]
    },
    
    // Footer
    footer: {
      contact: 'Contact Us',
      language: 'Language',
      copyright: '© 2024 EXOREVIVE BULGARIA. All rights reserved.',
      privacy: 'Privacy Policy',
      quickLinks: 'Quick Links',
      description: 'Innovative solutions in regenerative medicine',
      createdBy: 'Created by'
    },
    
    // Contact Page
    contact: {
      title: 'Contact Us',
      phone: {
        title: 'Phone'
      },
      email: {
        title: 'Email'
      },
      social: {
        title: 'Social Media'
      },
      form: {
        title: 'Send us a Message',
        name: {
          label: 'Your Name',
          placeholder: 'Enter your full name'
        },
        email: {
          label: 'Your Email',
          placeholder: 'Enter your email address'
        },
        message: {
          label: 'Your Message',
          placeholder: 'Enter your message here...'
        },
        button: {
          sending: 'Sending...',
          send: 'Send Message'
        }
      }
    }
  }
}; 